<template>
  <div class="sp-menu" :class="{ 'sp-menu--open': mainMenuVisible }">
    <div class="container">
      <div class="sp-menu__content">
        <p class="sp-menu__title">BROWSE TOPICS BY:</p>

        <ul class="sp-menu__list">
          <li class="sp-menu__item">
            <a class="sp-menu__link" :href="baseLink">All</a>
          </li>

          <li v-for="link in links" :key="link.id" class="sp-menu__item">
            <a class="sp-menu__link" :href="link.href">{{ link.title }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "SPMainMenu",
  props: {
    baseLink: String,
    links: Array,
  },
  computed: { ...mapFields(["mainMenuVisible"]) },
  components: {},
  methods: {},
};
</script>
